import type { CSSProperties } from "react";
import { cn } from "../lib/cn";

/**
 * Иконка из SVG-файла (набор Figma) с цветом через currentColor: файл используется как CSS-маска,
 * поэтому геометрия точная, а цвет управляется классами `text-*` (активный/неактивный, тёмная тема).
 */
export function SvgIcon({ src, size = 24, className, label, style }: { src: string; size?: number; className?: string; label?: string; style?: CSSProperties }) {
  const mask = `url("${src}") center / contain no-repeat`;
  return (
    <span
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      className={cn("inline-block shrink-0 bg-current", className)}
      style={{ width: size, height: size, mask, WebkitMask: mask, ...style }}
    />
  );
}
